export default __webpack_public_path__ + "static/media/logo.b60e29f7.svg";